import FeedbackManagerWrapper from "./feedback-manager-wrapper";

const FeedbackManager = () => {

  return (
    <div className="h-full flex flex-col text-text-500 w-full bg-primary-admin_foreground">
      <div className="flex-1">
        <FeedbackManagerWrapper />
      </div>
    </div>
  );
};

export default FeedbackManager;
